import "core-js/modules/es.object.from-entries.js";
import { SwanAssetFolders, SwanPathTypeEnum } from '../types/enums.js';
import { isTestEnv } from './env.utils.js';
import { SWAN_PUBLIC_ASSET_FOLDER, SWAN_VERSIONED_FOLDER, SWAN_HASHED_FOLDER } from '../constants/paths.js';
import { SWAN_BASE_CDN_URL } from '../constants/domains.js';

function getSwanAssetFolderName(folder) {
  switch (folder) {
    case SwanAssetFolders.FAVICONS:
      return 'favicons';

    case SwanAssetFolders.POLYFILLS:
      return 'polyfills';

    case SwanAssetFolders.FONTS:
      return 'fonts';

    case SwanAssetFolders.ICONS:
      return 'icons';

    case SwanAssetFolders.IMAGES:
      return 'images';

    case SwanAssetFolders.JS:
      return 'js';

    case SwanAssetFolders.STYLES:
      return 'styles';

    case SwanAssetFolders.THEMES:
      return 'themes';
  }
}

function getVersionPrefix() {
  var pathType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SwanPathTypeEnum.hashed;

  if (isTestEnv()) {
    return 'pkg-folder-test';
  }

  if (pathType === SwanPathTypeEnum.versioned) return SWAN_VERSIONED_FOLDER;
  return SWAN_HASHED_FOLDER;
}

function manifestResolve(manifest, key, folder) {
  var pathType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : SwanPathTypeEnum.hashed;
  var swanAssetBaseUrl = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : SWAN_BASE_CDN_URL;
  var manifestConfig = manifest[key];
  var fileName = manifestConfig[pathType] || manifestConfig.hashed || manifestConfig.versioned;

  if (fileName) {
    var versionPrefix = getVersionPrefix(pathType);
    var folderName = getSwanAssetFolderName(folder);
    return "".concat(swanAssetBaseUrl || '').concat(versionPrefix, "/").concat(folderName, "/").concat(fileName);
  }

  return null;
}

function getSameKeyValueMapForManifest(manifest) {
  return Object.fromEntries(Object.keys(manifest).map(function (k) {
    return [k, k];
  }));
}

function polyfillResolve(fileName) {
  var swanAssetBaseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SWAN_BASE_CDN_URL;
  var folderName = getSwanAssetFolderName(SwanAssetFolders.POLYFILLS);
  return "".concat(swanAssetBaseUrl).concat(SWAN_PUBLIC_ASSET_FOLDER, "/").concat(folderName, "/").concat(fileName);
}

export { getSameKeyValueMapForManifest, getSwanAssetFolderName, manifestResolve, polyfillResolve };